// Client-side API for fetching replay data

import { ReplayData, MatchSummary } from './ReplayTypes';

function getApiHost(): string {
  const isDev =
    window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1');
  return isDev ? 'http://localhost:8788' : 'https://wizard-duel-api.neenhouse.workers.dev';
}

export async function fetchReplayData(matchId: string): Promise<ReplayData | null> {
  try {
    const response = await fetch(`${getApiHost()}/api/match/${matchId}/replay`);
    if (!response.ok) {
      console.error('Failed to fetch replay:', response.status);
      return null;
    }
    return (await response.json()) as ReplayData;
  } catch (error) {
    console.error('Error fetching replay data:', error);
    return null;
  }
}

export async function fetchRecentMatches(playerName?: string): Promise<MatchSummary[]> {
  try {
    const params = new URLSearchParams({ limit: '20' });
    if (playerName) params.set('player', playerName);
    const response = await fetch(`${getApiHost()}/api/matches/recent?${params}`);
    if (!response.ok) return [];
    const data = (await response.json()) as { matches: MatchSummary[] };
    return data.matches;
  } catch (error) {
    console.error('Error fetching recent matches:', error);
    return [];
  }
}
